import { Controller } from "@hotwired/stimulus"

// Simple tab switching for admin detail pages.
//
// Usage:
//   <div data-controller="admin-tabs">
//     <button data-admin-tabs-target="tab" data-action="click->admin-tabs#switch" data-tab="uploads">Uploads</button>
//     <div data-admin-tabs-target="panel" data-tab="uploads">...</div>
//   </div>
//
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { initialTab: String }

  connect() {
    if (this.tabTargets.length === 0) return

    const requestedTab = this.hasInitialTabValue ? this.initialTabValue : this.tabTargets[0].dataset.tab
    const availableTab = this.tabTargets.some((tab) => tab.dataset.tab === requestedTab)
      ? requestedTab
      : this.tabTargets[0].dataset.tab

    this.activate(availableTab)
  }

  switch(event) {
    this.activate(event.currentTarget.dataset.tab)
  }

  activate(tabName) {
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tab === tabName
      tab.classList.toggle("text-emerald-600", isActive)
      tab.classList.toggle("border-emerald-600", isActive)
      tab.classList.toggle("text-gray-500", !isActive)
      tab.classList.toggle("border-transparent", !isActive)
    })

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.tab !== tabName)
    })
  }
}
